<template>
    <a href="#" class="btn btn-default" @click="updateView()">
        <i class="fa" :class="{ 'fa-th' : value, 'fa-sitemap' : !value }" aria-hidden="true"></i>
        <span v-if="value">Test View</span>
        <span v-else>Overview</span>
    </a>
</template>
<script>
    export default {

        props: {
            value: {
                type: Boolean,
                required: true,
            }
        },

        methods: {
            updateView() {
                Storage.set('view-type', !this.value);
                this.$emit('input', !this.value);
            }
        }
    }
</script>